module.exports = __webpack_public_path__ + "img/mt.d2f307f8.png";